import hotentUiUtils from '@/hotent-ui-util.js';
import { mapState } from "vuex";
export default {
  data() {
    return {
      subTableName: "",
      subTableIndex: -1,
      defaultReadonly:false
    }
  },
  computed: mapState({
    permission_sub: function () {
      //根据subTableName 判断是否为子表组件
      if (this.subTableName && this.permission != 'n' && this.permission != 'r' && this.defaultReadonly) {
        if (this.$store.state.form.canEidtSubTableAndIndex == (this.subTableName + '' + this.subTableIndex)) {
          return this.permission;
        } else {
          return 'r';
        }
      }
      return this.permission;
    },
  }),
  mounted() {
    const { subScopeEl, index } = hotentUiUtils.getSubScopeElAndIndex(this.$el);
    if (subScopeEl && subScopeEl.dataset["subname"]) {
      this.subTableName = subScopeEl.dataset["subname"].split('.')[2].replace('sub_', '');
      this.subTableIndex = index;
      this.defaultReadonly = subScopeEl.getAttribute("default-readonly");
    }
  },
}